export const formatErrorMessage = (errorMessages: { [key: string]: string[] }) => {
  return Object.entries(errorMessages)
    .map(([key, messages]) => {
      const formattedKey = key.replace(/_/g, ' ');
      return `${formattedKey}: ${messages.join(', ')}`;
    })
    .join('\n');
};
